import { getIndicatorHtml, translateGearName } from '../utils/formatters.js';
import { calculateStats } from '../utils/stats.js';
import { updateRadioBtnStyles } from '../utils/ui.js';

export function initRankings() {
    const gearData = window.GEAR_DATA;
    if (!gearData) return;

    const targetRadios = document.querySelectorAll('input[name="target_toggle"]');
    const phaseRadios = document.querySelectorAll('input[name="phase_toggle"]');
    const troopRadios = document.querySelectorAll('input[name="troop_toggle"]');
    // vs Player toggle: when checked (ON), SOP stats are excluded from mssop calculations
    const vsPlayerCheckbox = document.getElementById('toggle_vs_player');
    const vsPlayerContainer = document.getElementById('rankings_vs_player_container');
    const resultsContainer = document.getElementById('rankings_results');
    const troopTypeContainer = document.getElementById('rankings_troop_type_container');

    // Base slots for Troops and Dragons
    // Base slots for Troops and Dragons
    const baseSlots = ['helmet', 'chest', 'pants', 'weapon', 'ring', 'boots'];

    function renderRankings() {
        const targetEl = document.querySelector('input[name="target_toggle"]:checked');
        const phaseEl = document.querySelector('input[name="phase_toggle"]:checked');
        const troopEl = document.querySelector('input[name="troop_toggle"]:checked');

        if (!targetEl || !phaseEl || !troopEl) return;

        const target = targetEl.value;
        let phase = phaseEl.value;
        let troopType = troopEl.value;

        // Toggle visibility of Caps phase label and fallback if necessary
        const capsPhaseLabel = document.querySelector('input[name="phase_toggle"][value="caps"]').parentNode;
        if (target === 'dragons' || target === 'pit') {
            capsPhaseLabel.style.display = 'none';
            if (phase === 'caps') {
                const attackRadio = document.querySelector('input[name="phase_toggle"][value="attack"]');
                if (attackRadio) {
                    attackRadio.checked = true;
                    phase = 'attack';
                }
            }
        } else {
            capsPhaseLabel.style.display = '';
        }

        // includeSop: true = show all stats (default); false = exclude SOP stat (toggle ON)
        // Only applies to mssop phase and caps/Rally; reinsop is always unaffected.
        const isCapsRally = phase === 'caps' && (troopType === 'Rally' || (troopType !== 'Rally' && troopType !== 'Rein'));
        const includeSop = ((phase === 'mssop' || isCapsRally) && vsPlayerCheckbox && vsPlayerCheckbox.checked)
            ? false
            : true;

        // Determine logical target for calculations, headers, and scoring description
        let logicalTarget = target;
        let activeSlots = baseSlots;

        if (target === 'trinkets') {
            activeSlots = ['trinket'];
            if (troopType === 'Dragons') {
                logicalTarget = 'dragons';
            } else {
                logicalTarget = 'troops';
            }
        } else if (target === 'pit') {
            activeSlots = ['saddle', 'chanfron', 'peytral'];
        }

        const showMoreEnabled = logicalTarget === 'troops' && (phase === 'attack' || phase === 'defense');

        // Update Algorithm Breakdown display using the resolved logical target and original target
        updateAlgorithmBreakdown(phase, logicalTarget, target, troopType, includeSop);

        // Show the vs Player toggle only on March Size phase or Caps Rally phase
        if (vsPlayerContainer) {
            const isCapsRally = phase === 'caps' && (troopType === 'Rally' || (troopType !== 'Rally' && troopType !== 'Rein'));
            vsPlayerContainer.style.display = (phase === 'mssop' || isCapsRally) ? '' : 'none';
        }

        // Toggle visibility of troop type selector
        const infoBtn = document.getElementById('algorithm-info-btn');
        if (target === 'dragons' || (target === 'pit' && (phase === 'mssop' || phase === 'reinsop')) || (target === 'troops' && phase === 'reinsop')) {
            troopTypeContainer.style.display = 'none';
        } else {
            troopTypeContainer.style.display = '';
        }

        // Info button is globally visible
        if (infoBtn) infoBtn.style.display = '';

        // Show/hide the relevant options in the troop type toggle
        const dragonsTroopLabel = document.getElementById('troop_toggle_dragons_label');
        const rallyTroopLabel = document.getElementById('troop_toggle_rally_label');
        const reinTroopLabel = document.getElementById('troop_toggle_rein_label');
        const infLabel = document.querySelector('input[name="troop_toggle"][value="Infantry"]').parentNode;
        const cavLabel = document.querySelector('input[name="troop_toggle"][value="Cavalry"]').parentNode;
        const rngLabel = document.querySelector('input[name="troop_toggle"][value="Ranged"]').parentNode;

        if (phase === 'caps') {
            // Hide standard troop types
            infLabel.style.display = 'none';
            cavLabel.style.display = 'none';
            rngLabel.style.display = 'none';
            if (dragonsTroopLabel) dragonsTroopLabel.style.display = 'none';

            // Show Rally/Rein
            if (rallyTroopLabel) rallyTroopLabel.style.display = '';
            if (reinTroopLabel) reinTroopLabel.style.display = '';

            if (troopType !== 'Rally' && troopType !== 'Rein') {
                const rallyRadio = document.querySelector('input[name="troop_toggle"][value="Rally"]');
                if (rallyRadio) {
                    rallyRadio.checked = true;
                    troopType = 'Rally';
                }
            }
        } else {
            // Show standard troop types
            infLabel.style.display = '';
            cavLabel.style.display = '';
            rngLabel.style.display = '';

            // Hide Rally/Rein
            if (rallyTroopLabel) rallyTroopLabel.style.display = 'none';
            if (reinTroopLabel) reinTroopLabel.style.display = 'none';

            if (troopType === 'Rally' || troopType === 'Rein') {
                const infRadio = document.querySelector('input[name="troop_toggle"][value="Infantry"]');
                if (infRadio) {
                    infRadio.checked = true;
                    troopType = 'Infantry';
                }
            }

            if (dragonsTroopLabel) {
                // Only show Dragons tab when Trinkets is selected
                if (target === 'trinkets') {
                    dragonsTroopLabel.style.display = '';
                } else {
                    dragonsTroopLabel.style.display = 'none';
                    if (troopType === 'Dragons') {
                        const infRadio = document.querySelector('input[name="troop_toggle"][value="Infantry"]');
                        if (infRadio) {
                            infRadio.checked = true;
                            troopType = 'Infantry';
                        }
                    }
                }
            }
        }

        resultsContainer.innerHTML = '';

        // For each slot type (Helmet, Chest, etc.)
        activeSlots.forEach(slot => {
            const itemsInSlot = gearData[slot] || [];

            // Filter out items that are not applicable to the selected troop type
            // E.g. exclude Calvary specific gear if Infantry is selected.
            // Items with no specific class "Troop" or "SOP" or undefined are kept.

            let processedItems = itemsInSlot.map(item => {
                const { totalSum, healthSum, mults, dAtkSum, dDefSum, dHealthSum, pDragTroopAtk, pDragDH, pDragAtkBase, pMults, msBase, reinBase, msPercent, rallyBase, reinCapBase } = calculateStats(item, logicalTarget, phase, includeSop, troopType);

                // Check if the item aligns with the troop selection
                // If Target is dragons, we evaluate based on dragon relevance.
                let isClassMatch = false;
                if (phase === 'mssop' || phase === 'reinsop') {
                    // For MS SOP / Rein SOP, piece stats aren't restricted by troop type unless they are dragon-specific
                    if (troopType === 'Dragons' || logicalTarget === 'dragons' || logicalTarget === 'pit') {
                        // User explicitly looking for Dragon march sizes
                        // Restrict to pieces that have dragon stats or are of the class type Dragon.
                        const stats = item.stats || {};
                        let hasDragonMsStats = (stats["Dragon Max March Size"] || 0) > 0;

                        if (phase === 'mssop') {
                            // Dragon March Size vs Player is a vs-Player stat (not SOP-specific), always include it
                            hasDragonMsStats = hasDragonMsStats || (stats["Dragon March Size vs Player"] || 0) > 0 || (stats["Dragon March Size vs SOP"] || 0) > 0;
                        }

                        isClassMatch = !!hasDragonMsStats || item.class === 'Dragon';
                    } else {
                        // For infantry/cavalry/ranged, allow everything EXCEPT dragons AND conflicting troop types
                        // For standard Troop target in MS Rein, we combine all (Inf/Cav/Rng) and exclude Dragons
                        if (target === 'troops' && phase === 'reinsop') {
                            isClassMatch = item.class !== 'Dragon';
                        } else {
                            const conflictingTypes = ['Infantry', 'Ranged', 'Cavalry'].filter(t => t !== troopType);
                            isClassMatch = !conflictingTypes.includes(item.class) && item.class !== 'Dragon';
                        }

                        // If it's trinkets however, enforce explicit matching against the selected troop type
                        if (target === 'trinkets') {
                            isClassMatch = item.class === troopType || item.class === 'Troop' || item.class === 'SOP' || !item.class;
                        }

                        // Override: Allow Dragon pieces if they have relevant generic (non-dragon) MS stats
                        if (item.class === 'Dragon') {
                            const stats = item.stats || {};
                            let hasGenericMsStats = (stats["March Size"] || 0) > 0 || (stats["March Size Percent"] || 0) > 0;

                            if (phase === 'mssop') {
                                // 'Single March Size vs Player' is always relevant;
                                // 'March Size vs SOP' is only relevant when the vs Player toggle is OFF (includeSop=true)
                                hasGenericMsStats = hasGenericMsStats
                                    || (stats["Single March Size vs Player"] || 0) > 0
                                    || (includeSop && (stats["March Size vs SOP"] || 0) > 0);
                            } else {
                                hasGenericMsStats = hasGenericMsStats || (stats["March Size Reinforcing SOP"] || 0) > 0;
                            }

                            if (hasGenericMsStats) {
                                isClassMatch = true;
                            }
                        }
                    }

                    // Strict exception: Always allow Queen Mother gear in MS tabs
                    if (item.set_name === 'Queen Mother') {
                        isClassMatch = true;
                    }
                } else if (phase === 'caps') {
                    // Rally and Rein have no troop restriction. They apply to all.
                    if (target === 'trinkets') {
                        // Keep class specific trinks filtering or allow all?
                        // "They won't be troop specific so we can just show one set of charts for all troop types."
                        isClassMatch = true;
                    } else {
                        isClassMatch = true;
                    }
                } else if (logicalTarget === 'troops') {
                    let matchClass = troopType === 'Dragons' ? 'Dragon' : troopType;
                    // Explicitly exclude Dragon-class gear from Troop rankings EXCEPT when checking Dragon MS SOP
                    isClassMatch = item.class === matchClass || !item.class || item.class === 'Troop' || item.class === 'SOP';
                    if (!isClassMatch && phase === 'defense') {
                        const conflictingTypes = ['Infantry', 'Ranged', 'Cavalry'].filter(t => t !== troopType);
                        if (!conflictingTypes.includes(item.class)) {
                            isClassMatch = true;
                        }
                    }
                } else if (logicalTarget === 'dragons' || logicalTarget === 'pit') {
                    // For dragons/pit, match everything that provides relevant stats (filtered out in next step)
                    isClassMatch = true;
                }

                return {
                    ...item,
                    totalSum,
                    healthSum,
                    mults,
                    dAtkSum,
                    dDefSum,
                    dHealthSum,
                    pDragTroopAtk,
                    pDragDH,
                    pDragAtkBase,
                    pMults,
                    msBase,
                    reinBase,
                    msPercent,
                    rallyBase,
                    reinCapBase,
                    isClassMatch
                };
            }).filter(item => {
                if (phase === 'mssop') {
                    return item.isClassMatch && (item.msBase > 0 || item.msPercent > 0);
                } else if (phase === 'reinsop') {
                    return item.isClassMatch && (item.reinBase > 0 || item.msPercent > 0);
                } else if (phase === 'caps') {
                    if (troopType === 'Rally') {
                        return item.isClassMatch && item.rallyBase > 0;
                    } else {
                        return item.isClassMatch && item.reinCapBase > 0;
                    }
                }

                if (logicalTarget === 'troops') {
                    // Keep only items that are a class match AND provide stats or multipliers
                    const hasStats = item.totalSum > 0 || item.healthSum > 0 || item.mults.vInf > 0 || item.mults.vRng > 0 || item.mults.vCav > 0;
                    return item.isClassMatch && hasStats;
                } else if (logicalTarget === 'dragons') {
                    // For dragons, filtering depends strictly on having relative Dragon stats
                    if (phase === 'attack') {
                        return item.dAtkSum > 0;
                    } else if (phase === 'defense') {
                        return item.dDefSum > 0 || item.dHealthSum > 0;
                    }
                } else if (logicalTarget === 'pit') {
                    // Filtering for Pit gear depends on specific Pit stats based on phase
                    if (phase === 'attack') {
                        return item.pDragTroopAtk > 0 || item.pMults.vInf > 0 || item.pMults.vRng > 0 || item.pMults.vCav > 0 || item.pDragAtkBase > 0;
                    } else if (phase === 'defense') {
                        return item.pDragDH > 0 || item.pMults.vInf > 0 || item.pMults.vRng > 0 || item.pMults.vCav > 0 || item.pDragAtkBase > 0;
                    }
                }
                return false;
            });

            // Calculate ranking score and sort
            processedItems.forEach(item => {
                if (phase === 'mssop' || phase === 'reinsop') {
                    let pct = item.msPercent || 0;
                    let baseVal = phase === 'mssop' ? item.msBase : item.reinBase;
                    item.selfScore = baseVal + (baseVal * (pct / 100));
                } else if (phase === 'caps') {
                    item.selfScore = troopType === 'Rally' ? item.rallyBase : item.reinCapBase;
                    item.rankScore = item.selfScore; // Using rankScore for normal sorting
                } else if (logicalTarget === 'troops') {
                    let baseStat = item.totalSum;
                    // Note: Health is no longer added to baseStat here for scaling

                    const calcScore = (mult) => {
                        return (baseStat / 100 * mult) + baseStat + mult;
                    };

                    const scoreInf = calcScore(item.mults.vInf);
                    const scoreRng = calcScore(item.mults.vRng);
                    const scoreCav = calcScore(item.mults.vCav);

                    // Apply dynamic troop cycle weights
                    // high: 1.7, med: 1.0, low: 0.3 (sums to 3)
                    let wInf = 1.0, wRng = 1.0, wCav = 1.0;

                    if (phase === 'defense') {
                        if (troopType === 'Infantry') {
                            wRng = 1.7; wInf = 1.0; wCav = 0.3;
                        } else if (troopType === 'Ranged') {
                            wCav = 1.7; wRng = 1.0; wInf = 0.3;
                        } else if (troopType === 'Cavalry') {
                            wInf = 1.7; wCav = 1.0; wRng = 0.3;
                        }
                    } else if (phase === 'attack') {
                        if (troopType === 'Infantry') {
                            wCav = 1.7; wInf = 1.0; wRng = 0.3;
                        } else if (troopType === 'Ranged') {
                            wInf = 1.7; wRng = 1.0; wCav = 0.3;
                        } else if (troopType === 'Cavalry') {
                            wRng = 1.7; wCav = 1.0; wInf = 0.3;
                        }
                    }

                    let rankScore = Math.round(((scoreInf * wInf) + (scoreRng * wRng) + (scoreCav * wCav)) / 3);

                    // Tie breakers
                    let multiplierCount = 0;
                    if (item.mults.vInf > 0) multiplierCount++;
                    if (item.mults.vRng > 0) multiplierCount++;
                    if (item.mults.vCav > 0) multiplierCount++;

                    const multiplierBonus = Math.round((baseStat * 0.25) * multiplierCount);

                    // Add flat health as a supplementary tie breaker during defense phase
                    const healthBonus = phase === 'defense' ? item.healthSum : 0;

                    item.rankScore = Math.round(rankScore + multiplierBonus + healthBonus);
                } else if (logicalTarget === 'dragons') {
                    if (phase === 'attack') {
                        // Rank simply by DvD (Dragon Attack vs Dragons)
                        item.rankScore = item.dAtkSum;
                    } else if (phase === 'defense') {
                        // Rank strictly by Dragon Defense
                        item.rankScore = item.dDefSum;
                    }
                } else if (logicalTarget === 'pit') {
                    if (phase === 'attack') {
                        item.rankScore = item.pDragTroopAtk; // Score by Drag: Troop Attack
                    } else if (phase === 'defense') {
                        item.rankScore = item.pDragDH; // Score by total Drag: D/H
                    }
                }
            });

            if (phase === 'mssop' || phase === 'reinsop') {
                processedItems.forEach(item => {
                    let pct = item.msPercent;
                    let baseVal = phase === 'mssop' ? item.msBase : item.reinBase;
                    item.selfScore = baseVal + (baseVal * (pct / 100));
                });
            }

            let topItems = [];
            if (phase === 'mssop' || phase === 'reinsop') {
                const baseKey = phase === 'mssop' ? 'msBase' : 'reinBase';
                const limit = (slot === 'trinket') ? 8 : (target === 'pit' || (target === 'troops' && phase === 'reinsop')) ? 5 : 3;

                // 1. Items with both Base MS and March %
                const bothPieces = processedItems.filter(i => i[baseKey] > 0 && i.msPercent > 0);
                bothPieces.sort((a, b) => {
                    if (b.selfScore !== a.selfScore) return b.selfScore - a.selfScore;
                    return b.msPercent - a.msPercent;
                });
                const topBoth = bothPieces.slice(0, limit);

                // 2. Items with ONLY Base MS
                const baseOnlyPieces = processedItems.filter(i => i[baseKey] > 0 && (!i.msPercent || i.msPercent === 0));
                baseOnlyPieces.sort((a, b) => b[baseKey] - a[baseKey]);
                const topBaseOnly = baseOnlyPieces.slice(0, limit);

                // 3. Items with ONLY March %
                const pctOnlyPieces = processedItems.filter(i => i.msPercent > 0 && (!i[baseKey] || i[baseKey] === 0));
                pctOnlyPieces.sort((a, b) => b.msPercent - a.msPercent);
                const limitPct = (slot === 'trinket') ? 8 : (target === 'pit' || (target === 'troops' && phase === 'reinsop')) ? 5 : 4;
                const topPctOnly = pctOnlyPieces.slice(0, limitPct);

                topItems = [...topBoth, ...topBaseOnly, ...topPctOnly];

                // Sort the final combined list to ensure absolute strongest are at the top
                topItems.sort((a, b) => {
                    if (b.selfScore !== a.selfScore) return b.selfScore - a.selfScore;
                    return b.msPercent - a.msPercent;
                });
            } else if (phase === 'caps') {
                processedItems.sort((a, b) => b.rankScore - a.rankScore);
                topItems = processedItems.slice(0, (slot === 'trinket' ? 8 : 5));
            } else {
                processedItems.sort((a, b) => b.rankScore - a.rankScore);
                // Dragons defense or any Trinket view shows up to 8 items; all other views show 5
                const limit = (logicalTarget === 'dragons' && phase === 'defense') || (slot === 'trinket') ? 8 : 5;
                if (showMoreEnabled) {
                    // Limit trinkets to 10 items total so they only expand one level (5 initial + 5 more)
                    topItems = slot === 'trinket' ? processedItems.slice(0, 10) : processedItems;
                } else {
                    topItems = processedItems.slice(0, limit);
                }
            }

            if (topItems.length === 0) return;

            // Render the HTML
            const section = document.createElement('div');
            section.className = 'ranking-slot-section scenario-container';

            const title = slot === 'trinket' ? 'Trinkets' : slot.charAt(0).toUpperCase() + slot.slice(1);
            let html = `<h3 class="scenario-title">${title}</h3>`;
            const tableClass = logicalTarget === 'pit'
                ? 'comparison-table rankings-table pit-rankings-table'
                : logicalTarget === 'troops'
                    ? 'comparison-table rankings-table troops-rankings-table'
                    : 'comparison-table rankings-table';
            html += `<div class="table-responsive">
                     <table class="${tableClass}">
                        <thead>
                            <tr>
                                <th>Gear Name</th>`;

            if (phase === 'mssop') {
                // Column header reflects whether the SOP stat is included or stripped out
                const msBaseColHeader = includeSop ? 'vs Player at SOP' : 'vs Player';
                html += `   <th>${msBaseColHeader}</th>
                            <th>March Size %</th>
                            </tr>
                        </thead>
                        <tbody>`;
            } else if (phase === 'reinsop') {
                html += `   <th>MS reinforcing SOP</th>
                            <th>March Size %</th>
                            </tr>
                        </thead>
                        <tbody>`;
            } else if (phase === 'caps') {
                if (troopType === 'Rally') {
                    const rallyColHeader = includeSop ? 'Rally Capacity at SOP' : 'Rally Capacity';
                    html += `   <th>${rallyColHeader}</th>
                            </tr>
                        </thead>
                        <tbody>`;
                } else {
                    html += `   <th>Rein Capacity for SOP</th>
                            </tr>
                        </thead>
                        <tbody>`;
                }
            } else if (logicalTarget === 'troops') {
                html += `       <th>vInf</th>
                                <th>vRng</th>
                                <th>vCav</th>`;

                if (phase === 'attack') {
                    html += `   <th>Total Attack</th>
                                <th>Score</th>
                            </tr>
                        </thead>
                        <tbody>`;
                } else {
                    html += `   <th>Total Defense</th>
                                <th>Total Health</th>
                                <th>Score</th>
                            </tr>
                        </thead>
                        <tbody>`;
                }
            } else if (logicalTarget === 'dragons') {
                if (phase === 'attack') {
                    html += `   <th>DvD</th>
                                <th>Troop Attack</th>
                                <th>Troop D/H</th>
                            </tr>
                        </thead>
                        <tbody>`;
                } else {
                    html += `   <th>Dragon Defense</th>
                                <th>Dragon Health</th>
                                <th>Troop D/H</th>
                            </tr>
                        </thead>
                        <tbody>`;
                }
            } else if (logicalTarget === 'pit') {
                html += `   <th>Drag: Troop Attack</th>
                            <th>Drag: Troop D/H</th>
                            <th>Dragon Attack</th>`;

                if (troopType === 'Infantry') {
                    html += `   <th>vCav</th>
                                <th>vInf</th>
                                <th>vRng</th>`;
                } else if (troopType === 'Ranged') {
                    html += `   <th>vInf</th>
                                <th>vRng</th>
                                <th>vCav</th>`;
                } else if (troopType === 'Cavalry') {
                    html += `   <th>vRng</th>
                                <th>vCav</th>
                                <th>vInf</th>`;
                }

                html += `   </tr>
                        </thead>
                        <tbody>`;

                // Add class to table for specific Pit styling
                setTimeout(() => {
                    const lastTable = resultsContainer.querySelector('.ranking-slot-section:last-child table');
                    if (lastTable) lastTable.classList.add('pit-rankings-table');
                }, 0);
            }

            const getValHtml = (val) => {
                return `<td>${val || 0}</td>`;
            };



            topItems.forEach((item, index) => {
                // Highlight top rank or apply alternating zebra background
                let rowClass = '';
                if (index === 0) {
                    rowClass = 'top-rank';
                } else if (index % 2 === 0) {
                    rowClass = 'zebra';
                }

                let rowStyle = '';
                if (showMoreEnabled && index >= 5) {
                    rowClass += ' hidden-row';
                    rowStyle = ' style="display: none;"';
                }

                const vInfVal = item.mults.vInf;
                const vRngVal = item.mults.vRng;
                const vCavVal = item.mults.vCav;



                // Remove emoji and append season
                let displaySeason = item.season;
                if (slot === 'trinket') {
                    if (item.season == 1) displaySeason = 'I';
                    else if (item.season == 2) displaySeason = 'II';
                    else if (item.season == 3) displaySeason = 'III';
                    else if (item.season == 4) displaySeason = 'IV';
                    else if (item.season == 0) displaySeason = null;
                }
                const seasonStr = displaySeason ? `(${displaySeason})` : '';
                // Use a very safe regex for cleaning, handle potential null name
                const rawName = item.name || 'Unknown';
                const cleanName = rawName.replace(/^\W+/, '').trim();
                const translatedName = translateGearName ? translateGearName(cleanName) : cleanName;
                const displayName = `${translatedName} ${seasonStr}`.trim();

                // Only block Chrome translation if we successfully replaced it with our local dictionary
                const translateAttr = (translatedName !== cleanName) ? ' translate="no"' : '';

                html += `<tr class="${rowClass}"${rowStyle}>
                            <td style="text-align:left;"${translateAttr}>${displayName}</td>`;

                if (phase === 'mssop') {
                    html += `   ${getValHtml(item.msBase ? item.msBase.toLocaleString() : 0)}
                                ${getValHtml(item.msPercent ? (Math.round(item.msPercent * 10) / 10).toLocaleString() : 0)}</tr>`;
                } else if (phase === 'reinsop') {
                    html += `   ${getValHtml(item.reinBase ? item.reinBase.toLocaleString() : 0)}
                                ${getValHtml(item.msPercent ? (Math.round(item.msPercent * 10) / 10).toLocaleString() : 0)}</tr>`;
                } else if (phase === 'caps') {
                    const capVal = troopType === 'Rally' ? item.rallyBase : item.reinCapBase;
                    html += `   ${getValHtml(capVal ? capVal.toLocaleString() : 0)}</tr>`;
                } else if (logicalTarget === 'troops') {
                    html += `   ${getValHtml(vInfVal)}
                                ${getValHtml(vRngVal)}
                                ${getValHtml(vCavVal)}`;

                    if (phase === 'attack') {
                        html += `<td style="font-weight:bold;">${item.totalSum}</td>
                                 <td class="score-cell">${item.rankScore}</td></tr>`;
                    } else {
                        html += `<td style="font-weight:bold;">${item.totalSum}</td>
                                 <td>${item.healthSum}</td>
                                 <td class="score-cell">${item.rankScore}</td></tr>`;
                    }
                } else if (logicalTarget === 'dragons') {
                    if (phase === 'attack') {
                        let totalSumHtml = `${item.totalSum}`;
                        if (item.class && ['infantry', 'ranged', 'cavalry'].includes(item.class.toLowerCase())) {
                            totalSumHtml = `<div class="stat-value-container"><span>${item.totalSum}</span>${getIndicatorHtml(item.class)}</div>`;
                        }

                        html += `<td style="font-weight:bold;">${item.dAtkSum}</td>
                                 <td>${totalSumHtml}</td>
                                 <td>${item.healthSum}</td></tr>`;
                    } else {
                        html += `<td style="font-weight:bold;">${item.dDefSum}</td>
                                 <td>${item.dHealthSum}</td>
                                 <td>${item.totalSum}</td></tr>`;
                    }
                } else if (logicalTarget === 'pit') {
                    const atkBold = phase === 'attack' ? 'font-weight:bold;' : '';
                    const dhBold = phase === 'defense' ? 'font-weight:bold;' : '';

                    html += `<td style="${atkBold}">${item.pDragTroopAtk}</td>
                             <td style="${dhBold}">${item.pDragDH}</td>
                             <td>${item.pDragAtkBase}</td>`;

                    let preyVal, sameVal, weaknessVal;
                    if (troopType === 'Infantry') {
                        preyVal = item.pMults.vCav; // Infantry beats Cavalry
                        sameVal = item.pMults.vInf;
                        weaknessVal = item.pMults.vRan;
                    } else if (troopType === 'Ranged') {
                        preyVal = item.pMults.vInf; // Ranged beats Infantry
                        sameVal = item.pMults.vRan;
                        weaknessVal = item.pMults.vCav;
                    } else if (troopType === 'Cavalry') {
                        preyVal = item.pMults.vRan; // Cavalry beats Ranged
                        sameVal = item.pMults.vCav;
                        weaknessVal = item.pMults.vInf;
                    }

                    html += `   ${getValHtml(preyVal)}
                                ${getValHtml(sameVal)}
                                ${getValHtml(weaknessVal)}</tr>`;
                }

            });

            html += `</tbody></table></div>`;
            if (showMoreEnabled && topItems.length > 5) {
                html += `
                <div class="show-more-btn-container">
                    <button class="show-more-btn">
                        <span>Show More</span>
                        <svg class="chevron-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                </div>`;
            }
            section.innerHTML = html;
            resultsContainer.appendChild(section);
        });

        // Update label highlight logic locally for radio buttons
        updateRadioBtnStyles('.radio-btn-group label');
    }

    // Attach listeners
    targetRadios.forEach(r => r.addEventListener('change', renderRankings));
    phaseRadios.forEach(r => r.addEventListener('change', renderRankings));
    troopRadios.forEach(r => r.addEventListener('change', renderRankings));
    if (vsPlayerCheckbox) vsPlayerCheckbox.addEventListener('change', renderRankings);

    if (resultsContainer) {
        resultsContainer.addEventListener('click', (e) => {
            const btn = e.target.closest('.show-more-btn');
            if (!btn) return;
            
            btn.blur();
            
            const section = btn.closest('.ranking-slot-section');
            if (!section) return;
            
            const textSpan = btn.querySelector('span');
            
            if (btn.classList.contains('show-less-state')) {
                // Collapse back to 5 items
                const allRows = section.querySelectorAll('tbody tr');
                allRows.forEach((row, idx) => {
                    if (idx >= 5) {
                        row.classList.add('hidden-row');
                        row.style.display = 'none';
                    }
                });
                if (textSpan) textSpan.textContent = 'Show More';
                btn.classList.remove('show-less-state');
            } else {
                // Show next 5 hidden rows
                const hiddenRows = section.querySelectorAll('tbody tr.hidden-row');
                let shownCount = 0;
                hiddenRows.forEach(row => {
                    if (shownCount < 5) {
                        row.classList.remove('hidden-row');
                        row.style.display = '';
                        shownCount++;
                    }
                });
                
                // Switch to Show Less state if no hidden rows remain
                const remainingHidden = section.querySelectorAll('tbody tr.hidden-row');
                if (remainingHidden.length === 0) {
                    if (textSpan) textSpan.textContent = 'Show Less';
                    btn.classList.add('show-less-state');
                }
            }
        });
    }

    // Initial render
    renderRankings();

    // Algorithm Info Toggle
    const infoBtn = document.getElementById('algorithm-info-btn');
    const closeBreakdownBtn = document.getElementById('close-breakdown-btn');
    const breakdownModal = document.getElementById('algorithm-breakdown-modal');
    const rankingsContainer = document.querySelector('.rankings-container');

    if (infoBtn && breakdownModal) {
        infoBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            breakdownModal.classList.add('visible');
            if (rankingsContainer) rankingsContainer.style.overflow = 'hidden';
        });
    }

    if (closeBreakdownBtn && breakdownModal) {
        closeBreakdownBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            breakdownModal.classList.remove('visible');
            if (rankingsContainer) rankingsContainer.style.overflow = '';
        });
    }

    // Close breakdown when clicking outside the modal content
    const dismissBreakdown = (e) => {
        if (breakdownModal && breakdownModal.classList.contains('visible')) {
            const modalContent = breakdownModal.querySelector('.modal-content');
            const isClickInside = modalContent && modalContent.contains(e.target);
            const isClickOnInfoBtn = infoBtn && infoBtn.contains(e.target);

            if (!isClickInside && !isClickOnInfoBtn) {
                breakdownModal.classList.remove('visible');
                if (rankingsContainer) rankingsContainer.style.overflow = '';
            }
        }
    };

    document.addEventListener('wheel', dismissBreakdown, { passive: true });

    function updateAlgorithmBreakdown(phase, logicalTarget, originalTarget, troopType, includeSop = true) {
        const introEl = document.getElementById('algorithm-intro');
        const weightsContent = document.getElementById('algorithm-weights-content');
        const healthStep = document.getElementById('algorithm-step-health');
        const titleEl = document.getElementById('algorithm-breakdown-title');
        const complexSteps = document.getElementById('algorithm-complex-steps');
        const simpleSteps = document.getElementById('algorithm-simple-steps');
        const simpleDesc = document.getElementById('algorithm-simple-description');
        const disclaimerEl = document.getElementById('algorithm-level-disclaimer');

        if (!titleEl) return;

        if (disclaimerEl) {
            if (originalTarget === 'trinkets') {
                disclaimerEl.textContent = 'Leg 35 values used';
            } else {
                disclaimerEl.textContent = 'Leg 40 values used';
            }
        }

        // Update Title dynamically
        let targetTitle = originalTarget.charAt(0).toUpperCase() + originalTarget.slice(1);
        let phaseTitle = phase.charAt(0).toUpperCase() + phase.slice(1);

        if (phase === 'mssop') phaseTitle = 'March Size';
        if (phase === 'reinsop') phaseTitle = 'Rein SOP';
        if (phase === 'caps') {
            phaseTitle = troopType + ' Capacity';
            if (troopType === 'Rally' && includeSop) phaseTitle += ' at SOP';
        }

        titleEl.textContent = `${targetTitle} ${phaseTitle} Guide`;
        if (phase === 'mssop') {
            titleEl.setAttribute('aria-label', `${targetTitle} March Size SOP Guide`);
        } else {
            titleEl.removeAttribute('aria-label');
        }

        // Switch Layouts — logicalTarget is always 'troops', 'dragons', or 'pit'
        const isComplex = (logicalTarget === 'troops' && phase !== 'mssop' && phase !== 'reinsop' && phase !== 'caps');
        if (introEl) introEl.style.display = isComplex ? '' : 'none';
        if (complexSteps) complexSteps.style.display = isComplex ? '' : 'none';
        if (simpleSteps) simpleSteps.classList.toggle('hidden', isComplex);

        if (isComplex) {
            if (!weightsContent) return;
            // Hide health step for attack phase
            if (healthStep) {
                healthStep.style.display = phase === 'attack' ? 'none' : '';
            }

            const baseStatTypeEl = document.getElementById('algorithm-base-stat-type');
            if (baseStatTypeEl) {
                baseStatTypeEl.textContent = phase === 'attack' ? 'Attack' : 'Defense';
            }

            if (phase === 'attack') {
                weightsContent.innerHTML = `
                    <p>"Mult" is calculated by adjusting the multipliers against the troop cycle below, prioritizing attack power against your Prey. The average of these three values is then used:</p>
                    <div class="weight-grid">
                        <div class="weight-item"><span class="weight-label">Prey (Strong Against):</span> <span class="weight-value">1.7x</span></div>
                        <div class="weight-item"><span class="weight-label">Matching (Neutral):</span> <span class="weight-value">1.0x</span></div>
                        <div class="weight-item"><span class="weight-label">Threat (Weak Against):</span> <span class="weight-value">0.3x</span></div>
                    </div>
                `;
            } else {
                weightsContent.innerHTML = `
                    <p>"Mult" is calculated by adjusting the multipliers against the troop cycle below, prioritizing defense against your Threat. The average of these three values is then used:</p>
                    <div class="weight-grid">
                        <div class="weight-item"><span class="weight-label">Threat (Weak Against):</span> <span class="weight-value">1.7x</span></div>
                        <div class="weight-item"><span class="weight-label">Matching (Neutral):</span> <span class="weight-value">1.0x</span></div>
                        <div class="weight-item"><span class="weight-label">Prey (Strong Against):</span> <span class="weight-value">0.3x</span></div>
                    </div>
                `;
            }
        } else {
            // Simple summation scoring (Pit or Dragons — including Dragon Trinkets)
            if (!simpleDesc) return;

            let statsListHtml = '';
            let stats = [];
            let descText = "";

            if (phase === 'mssop') {
                if (logicalTarget === 'dragons' || logicalTarget === 'pit') {
                    if (includeSop) {
                        descText = "Ordered by the sum of stats making up Dragon March Size vs Player at SOP, then by March Size Percent.";
                        stats = ["Dragon Max March Size", "Dragon March Size vs Player", "Dragon March Size vs SOP", "March Size vs SOP", "March Size Percent"];
                    } else {
                        descText = "Ordered by Dragon Max March Size and Dragon March Size vs Player (SOP stat excluded), then by March Size Percent.";
                        stats = ["Dragon Max March Size", "Dragon March Size vs Player", "March Size Percent"];
                    }
                } else {
                    if (includeSop) {
                        descText = "Ordered by the sum of stats making up March Size vs Player at SOP, then by March Size Percent.";
                        stats = ["March Size", "Single March Size vs Player", "March Size vs SOP", "March Size Percent"];
                    } else {
                        descText = "Ordered by March Size and Single March Size vs Player (SOP stat excluded), then by March Size Percent.";
                        stats = ["March Size", "Single March Size vs Player", "March Size Percent"];
                    }
                }
            } else if (phase === 'reinsop') {
                if (logicalTarget === 'dragons' || logicalTarget === 'pit') {
                    descText = "Ordered by the sum of stats making up Dragon March Size Reinforcing SOP, then by March Size Percent.";
                    stats = ["Dragon Max March Size", "March Size Reinforcing SOP", "March Size Percent"];
                } else {
                    if (includeSop) {
                        descText = "Ordered by the sum of stats making up March Size Reinforcing SOP, then by March Size Percent.";
                        stats = ["March Size", "March Size Reinforcing SOP", "March Size Percent"];
                    }
                }
            } else if (phase === 'caps') {
                if (troopType === 'Rally') {
                    if (includeSop) {
                        descText = "Ordered by the sum of Rally Troop Capacity and Rallied Troops vs SOP.";
                        stats = ["Rally Troop Capacity", "Rallied Troops vs SOP"];
                    } else {
                        descText = "Ordered strictly by Rally Troop Capacity (SOP stat excluded).";
                        stats = ["Rally Troop Capacity"];
                    }
                } else {
                    descText = "Ordered strictly by Reinforcement Capacity for SOP.";
                    stats = ["Reinforcement Capacity for SOP"];
                }
            } else if (logicalTarget === 'pit') {
                if (phase === 'attack') {
                    descText = "Ordered by the sum of Dragon Troop Attack stats and Dragon Troop-Type stats that match your selected tab.";
                    stats = [
                        "Dragon Troop Attack",
                        `Dragon ${troopType} Attack`,
                        "Dragon Troop Attack vs Player",
                        `Dragon ${troopType} Attack vs Player`,
                        "Dragon Marcher Troop Attack vs Player",
                        `Dragon Marcher ${troopType} Attack vs Player`,
                        "Dragon Troop Attack at SOP",
                        `Dragon ${troopType} Attack at SOP`
                    ];
                } else if (phase === 'defense') {
                    descText = "Ordered by the sum of Dragon Troop Defense/Health stats and Dragon Troop-Type stats that match your selected tab.";
                    stats = [
                        "Dragon Troop Defense",
                        `Dragon ${troopType} Defense`,
                        "Dragon Troop Health",
                        `Dragon ${troopType} Health`,
                        "Dragon Troop Defense vs Player",
                        `Dragon ${troopType} Defense vs Player`,
                        "Dragon Troop Health vs Player",
                        `Dragon ${troopType} Health vs Player`,
                        "Dragon Defender Defense",
                        "Dragon Defender Health",
                        "Dragon Troop Defense at SOP",
                        `Dragon ${troopType} Defense at SOP`,
                        "Dragon Troop Health at SOP",
                        `Dragon ${troopType} Health at SOP`
                    ];
                }
            } else if (logicalTarget === 'dragons') {
                if (phase === 'attack') {
                    descText = "Ordered by the Dragon Attack vs Dragons (DvD) value.";
                    stats = [
                        "<b>Dragon Attack vs Dragons</b>",
                        "Troop Attack",
                        "Troop Attack vs Player",
                        "Troop Attack While Marching vs Player",
                        "Troop Attack at SOP",
                        "Dragon Troop Attack",
                        "Dragon Troop Attack vs Player",
                        "Dragon Marcher Troop Attack vs Player",
                        "Dragon Troop Attack at SOP",
                        "(Troop-Type versions of the above)"
                    ];
                } else if (phase === 'defense') {
                    descText = "Ordered by Dragon Defense. Shows the top 8 pieces per slot.";
                    stats = [
                        "<b>Dragon Defense</b>",
                        "Dragon Health",
                        "Troop Defense",
                        "Troop Defense vs Player",
                        "Defender Defense",
                        "Dragon Troop Defense",
                        "Dragon Defender Defense",
                        "Dragon Troop Defense vs Player",
                        "Troop Defense at SOP",
                        "Dragon Troop Defense at SOP",
                        "(Health versions of the above)",
                        "(Troop-Type versions of the above)"
                    ];
                }
            }

            if (stats.length > 0) {
                statsListHtml = `<div class="stats-used-list" style="margin-top: 15px;">
                    <strong>Relevant Stats:</strong>
                    <ul style="margin-top: 5px; padding-left: 20px;">
                        ${stats.map(s => `<li>${s}</li>`).join('')}
                    </ul>
                </div>`;
            }

            simpleDesc.innerHTML = `<p>${descText}</p>${statsListHtml}`;
        }
    }
}
